/* Portal configurations - global scope */

const helper = {};

// base config
helper.portal_name = 'Concertto';
helper.portal_url = "concertto.live";
helper.type='concerts';

// api methods
helper.api_url = 'https://api.hubdelivery.io';
helper.api_methods = {
    'concerts': {
        'categories': '/content/concerts/categories',
        'concerts_by_category': '/content/concerts/concerts_by_category',
        'concert': '/content/concerts/concert',
        'concert_view': '/content/concerts/concert_view'
    },
    'legals': {
        'contact': '/content/legals/contact',
        'faq': '/content/legals/faq',
        'terms': '/content/legals/terms',
        'customer_service_policy': '/content/legals/customer_service_policy',
        'privacy': '/content/legals/privacy',
        'cookies_policy': '/content/legals/cookies_policy',
        'unsubscribe_text': '/content/legals/unsubscribe',
        'unsubscribe_phone': '/store/UnsubscribePhoneNumber'
    },
    'general': {
        'login': '/store/checkAccessCode',
        'login_phone': '/store/loginWithPhone',
        'check_phone_login': '/store/checkPhoneLoginAllowed'
    }
};

helper.country_phone_format = {
    'UK': '07XXXXXXXXX',
    'RO': '07xxxxxxxx',
    'SK': '09xxxxxxxx',
    'LV': '2xxxxxxx',
    'CZ': '7xxxxxxxx',
    'DK': 'xxxxxxxx',
    'BG': '08xxxxxxxx',
    'TR': '05xxxxxxxxx',
    'PL': 'xxxxxxxxx',
    'AT': '06xxxxxxxxx',
    'RS': '06xxxxxxxx',
    'SG': '6xxxxxxxxx',
    'SE': '07xxxxxxxx',
    'CH': '07xxxxxxxx',
    'TH': '0xxxxxxxxx'
};

helper.country_default_language = {
    'UK': 'EN',
    'DK': 'DK',
    'TR': 'TR',
    'CH': 'CH'
};

helper.country_register_landing = {
    'UK': 'https://uk.concertto.live/register',
    'RO': 'https://premium.concertto.live/rOCt98/',
    'CZ': 'https://premium.concertto.live/cZCT02/',
    'LV': 'https://premium.concertto.live/lVCT03/mo/',
    'RS': 'https://premium.concertto.live/rSCt01/',
    'SG': 'https://premium.concertto.live/sGCt01/',
    'CH': 'https://premium.concertto.live/cHCt01/',
    'SE': 'https://premium.concertto.live/sECt01/',
    'TH': 'https://premium.concertto.live/tHCt01/'
};

export const helpers = helper;